import React from "react";
import LegalLayout from "@/components/LegalLayout";
import SEOHead from "@/components/SEOHead";

export default function Terms() {
  return (
    <>
      <SEOHead route="terms" />
      <LegalLayout
        title={
          <>
            Terms &{" "}
            <span className="italic text-[#c01515]">conditions.</span>
          </>
        }
        kicker="Legal · 02"
        lastUpdated="29 April 2026"
      >
      <p>
        Welcome. These Terms and Conditions ("Terms") govern your access to
        and use of www.ranjanabaruah.com (the "Site") owned and operated by
        Ranjana Suman Baruah ("we", "our", "us"). By visiting or using the
        Site, you agree to be bound by these Terms. If you do not agree,
        please discontinue use of the Site.
      </p>

      <h2 className="font-display text-2xl md:text-3xl text-white mt-10 mb-2">
        1. Use of the Site
      </h2>
      <p>
        The Site is provided for personal, informational and creative
        purposes. You agree not to misuse the Site, attempt to gain
        unauthorised access to any portion of it, interfere with its
        operation, or use it for any unlawful activity.
      </p>

      <h2 className="font-display text-2xl md:text-3xl text-white mt-10 mb-2">
        2. Intellectual property
      </h2>
      <p>
        All content displayed on the Site — including but not limited to
        text, photographs, portraits, video footage, audio recordings,
        scripts, transcripts, monologues, the project "BRUTAL DESIGN" and any
        associated stills, posters, dialogue, design elements, typography
        treatment and overall visual identity — is the exclusive property of
        Ranjana Suman Baruah and is protected by copyright, trademark and
        other intellectual-property laws.
      </p>
      <p>
        No part of this Site may be copied, reproduced, republished,
        downloaded, posted, broadcast, transmitted, modified, distributed,
        used to train any artificial-intelligence model, or otherwise
        exploited in any form or by any means, in whole or in part, without
        the express prior written consent of Ranjana Suman Baruah.
      </p>

      <h2 className="font-display text-2xl md:text-3xl text-white mt-10 mb-2">
        3. Image rights & likeness
      </h2>
      <p>
        All photographs, portraits, video stills, performance footage, voice
        recordings, monologue scripts and any other visual or audio likeness
        of Ranjana Suman Baruah ("the Likeness") published on this Site
        remain her exclusive property and are protected as personality
        rights, copyright works and trademarks of personal identity under
        applicable law.
      </p>
      <p>
        The Likeness may not be downloaded, screen-captured, reproduced,
        redistributed, retouched, modified, mirrored, used in any
        compilation, magazine, social-media post, blog, advertisement,
        look-book, mood-board, casting database, machine-learning dataset,
        generative-AI training corpus, or in any commercial or
        non-commercial product — in whole or in part, in any form or by any
        means, currently known or hereafter devised — without the express
        prior written consent of Ranjana Suman Baruah.
      </p>
      <p>
        Bona-fide press, casting directors and production houses may request
        a written image-use grant for a specific publication or audition by
        writing to{" "}
        <a
          href="mailto:ranjanabaruah.93@gmail.com"
          className="text-[#c01515] hover:underline"
        >
          ranjanabaruah.93@gmail.com
        </a>
        . Unauthorised use will be treated as an infringement of
        personality and copyright rights and may result in immediate
        take-down notices, statutory damages and other legal remedies.
      </p>

      <h2 className="font-display text-2xl md:text-3xl text-white mt-10 mb-2">
        4. Permitted use
      </h2>
      <p>
        You may view the Site and download any document explicitly marked as
        downloadable (such as the watermarked monologue script PDF) for your
        personal, non-commercial reference only. Any commercial use, public
        screening, casting submission, or onward distribution requires
        written permission.
      </p>

      <h2 className="font-display text-2xl md:text-3xl text-white mt-10 mb-2">
        5. User submissions
      </h2>
      <p>
        Information you submit through the contact form ("Submissions") will
        be treated in accordance with our Privacy Policy. By submitting, you
        confirm that you have the right to share the information and that it
        is accurate, lawful and not infringing on any third-party rights. We
        reserve the right not to respond to any Submission.
      </p>

      <h2 className="font-display text-2xl md:text-3xl text-white mt-10 mb-2">
        6. Third-party links
      </h2>
      <p>
        The Site may contain links to external websites that are not owned
        or controlled by us. We are not responsible for the content,
        accuracy, opinions, privacy practices or availability of any such
        external sites and accessing them is at your own risk.
      </p>

      <h2 className="font-display text-2xl md:text-3xl text-white mt-10 mb-2">
        7. Disclaimers
      </h2>
      <p>
        The Site and its contents are provided on an "as is" and "as
        available" basis without warranties of any kind, whether express or
        implied. We make no warranty that the Site will be uninterrupted,
        error-free or free from harmful components.
      </p>

      <h2 className="font-display text-2xl md:text-3xl text-white mt-10 mb-2">
        8. Limitation of liability
      </h2>
      <p>
        To the maximum extent permitted by applicable law, Ranjana Suman
        Baruah shall not be liable for any indirect, incidental, special,
        consequential or punitive damages arising out of or relating to your
        use of, or inability to use, the Site.
      </p>

      <h2 className="font-display text-2xl md:text-3xl text-white mt-10 mb-2">
        9. Governing law & jurisdiction
      </h2>
      <p>
        These Terms shall be governed by and construed in accordance with
        the laws of India, without regard to conflict-of-law principles.
        Any dispute, controversy or claim arising out of or in relation to
        these Terms shall be subject to the <strong>exclusive
        jurisdiction of the competent courts at Guwahati, Assam, India</strong>{" "}
        and you irrevocably consent to that jurisdiction and venue.
      </p>

      <h2 className="font-display text-2xl md:text-3xl text-white mt-10 mb-2">
        10. Changes to these Terms
      </h2>
      <p>
        We may update these Terms periodically. The "Last updated" date at
        the top of this page reflects the most recent revision. Continued
        use of the Site after any changes constitutes your acceptance of the
        revised Terms.
      </p>

      <h2 className="font-display text-2xl md:text-3xl text-white mt-10 mb-2">
        11. Contact
      </h2>
      <p>
        For licensing requests, takedown notices or questions about these
        Terms, please write to{" "}
        <a
          href="mailto:ranjanabaruah.93@gmail.com"
          className="text-[#c01515] hover:underline"
        >
          ranjanabaruah.93@gmail.com
        </a>
        .
      </p>
      </LegalLayout>
    </>
  );
}
